import { BlankView } from "@/components";
import { constantsData } from "@/data";

export const OfflineModeBlankView = () => (
    <BlankView
        description={constantsData.msgs.offlineNetwork}
        title={constantsData.titles.offlineNetwork}
        actionBtnData={{
            onClick: () => window.location.reload(),
            text: constantsData.buttons.refresh,
        }}
        hasActionBtn
        hasDescription
        hasTitle
    />
);
